import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { Bar } from 'react-chartjs-2';

import { secondsToHHMMSS } from '../../utils/seconds-to-hhmmss';

export default function LongestEpisodes() {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson(
        sort: { fields: fields___durationSeconds, order: DESC }
        limit: 10
      ) {
        edges {
          node {
            id
            guest
            duration
            publishedAt(formatString: "MMM D, YYYY")
            gender
            fields {
              slug
              durationSeconds
            }
          }
        }
      }
    }
  `);

  const longestEp = data.allEpisodesJson.edges[0].node;
  const longest10 = data.allEpisodesJson.edges;
  const chartData = {
    labels: longest10.map(
      (ep) => `${ep.node.id} - ${ep.node.guest.replace(' | ', ', ')}`
    ),
    datasets: [
      {
        label: 'Duration',
        data: longest10.map((ep) => ep.node.fields.durationSeconds),
        backgroundColor: ['#3b85f2'],
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      y: {
        ticks: {
          color: '#d1d5db',
        },
        grid: {
          display: false,
        },
      },
      x: {
        title: {
          display: true,
          text: 'Duration (hours)',
          color: '#d1d5db',
        },
        min: 3.5 * 60 * 60,
        ticks: {
          color: '#d1d5db',
          count: 4,
          callback: function (value) {
            return `${(value / 60 / 60).toFixed(1)} h`;
          },
        },
        grid: {
          color: '#273045',
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            return `${label}: ${secondsToHHMMSS(context.parsed.x)}`;
          },
        },
      },
    },
  };

  return (
    <div className="max-w-xl">
      <h3 className="text-2xl">Longest episodes</h3>{' '}
      <p>
        <Link to={`/episodes/${longestEp.fields.slug}`}>
          #{longestEp.id} - {longestEp.guest.replace(' | ', ', ')}
        </Link>{' '}
        is the longest LFP episode of all time. It was released on{' '}
        {longestEp.publishedAt}, and is{' '}
        <span className="text-hl">
          {longestEp.duration.split(':')[0]} hours and{' '}
          {longestEp.duration.split(':')[1].replace(/^0/, '')} minutes
        </span>{' '}
        long.
      </p>
      <div className="mt-5 border border-gray-700 hover:border-gray-600 shadow-2xl rounded-md p-5 h-96">
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
}
